// Models
/**
 * Minimal entity for a locally-pinned task.
 * Used by the new My Tasks experience; persisted via IndexedDB only (no cross-device sync).
 */ export class PinnedTask {
    /**
     * Convert the pinned task to a persisted resource.
     */ forSerialization() {
        return {
            taskId: this.taskId
        };
    }
    /**
     * Construct a pinned task from a persisted resource.
     */ static fromPersistedResource(resource) {
        return new PinnedTask({
            taskId: resource.taskId
        });
    }
    constructor(properties){
        this.taskId = properties.taskId;
    }
}
